import { render, staticRenderFns } from "./DocumentDetailView.vue?vue&type=template&id=5b0c4e24&scoped=true&"
import script from "./DocumentDetailView.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=5b0c4e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c4e24",
  null
  
)

export default component.exports